
  export default {
    data() {
      return {
  
        form : {
                  id : '',
                  tahun : '',
                  satuan : '',
                  kecamatan : '',
                  skrining : '',
                  createAt : '',
                  editedAt : '',
              },
  
        tahun : '',
        sumber : '',
        total : '',
        kecamatan : '',
        nama_tahun : '',
        nama_kadis : '',
        nip_kadis : '',
       
        list_data : [],
        cetak_data : [],
        list_tahun : [],
        list_kecamatan : [],
  
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,
  
        mdl_add: false,
        mdl_download: false,
        mdl_cetak: false,
        mdl_print: false,
        mdl_edit: false,
        mdl_hapus : false,
        btn_add: false,
  
      }
    },
    methods: {
  
      getView : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_DINKES + "viewLansia", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,
                tahun : this.tahun
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.cetak_data = res_data.cetak;
                this.page_last = res_data.jml_data;
                this.$store.commit("hideLoading");
                this.nama_tahun = res_data.data[0].thn;
                console.log(res_data);
        });
      },

      getTotal : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_TOTAL + "dinkesLansia", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                tahun : this.tahun
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.$store.commit("hideLoading");
                this.total = res_data.data[0].total;
                console.log(res_data);
        });
      },

      getKadis : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit+"kadis", {
          method: "GET",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.nama_kadis = res_data[0].nama;
              this.nip_kadis = res_data[0].nip;
              this.$store.commit("hideLoading");
      });
    },
  
      getTahun : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Tahun, {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data);
                this.list_tahun = res_data;
                this.$store.commit("hideLoading");
        });
      },
  
      getKecamatan : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Kecamatan+"view", {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data);
                this.list_kecamatan = res_data;
  
                console.log(this.list_kecamatan);
                this.$store.commit("hideLoading");
        });
      },
  
      addData : function() {
        // var formData = new FormData();
        // formData.append('data', JSON.stringify(this.form))
        fetch(this.$store.state.url.URL_DINKES + "addLansia", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'indigo-10', 'check_circle_outline');
            console.log(res_data);
            this.getView();
        });
      },
  
  
      editData : function(){
        console.log(this.form);
        // var formData = new FormData();
        // formData.append('data', JSON.stringify(this.form))
        fetch(this.$store.state.url.URL_DINKES + "editLansia", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'lime-7', 'check_circle_outline');
            this.getView();
        });
      },
  
      removeData : function(a){
        fetch(this.$store.state.url.URL_DINKES + "removeLansia", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : a})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'deep-orange-10', 'check_circle_outline');
            this.getView();
        });
  
      },
  
      printTable() {
        const printWindow = window.open('', '_blank');
        const content = document.getElementById('printCetak').innerHTML;
        const style = `
          <link rel="stylesheet" type="text/css" href="css/bg.css">
          <style>
          table, td, th {  
            border: 1px solid #ddd;
          }
  
          .h_table_head{
              height: 50px;
              color: #282828;
          }
  
          .h_table_body{
              color: #343434;
              font-size: 13px;
              font-weight: 530;
          }
  
          table, td {  
            border: 1px solid #ddd;
          }
          
          table {
            border-collapse: collapse;
            width: 100%;
          }
          
          th, td {
            padding-left: 15px;
            padding-right: 15px;
            padding-top: 5px;
            padding-bottom: 5px;
          }
  
          tr:nth-child(even) {background-color: #eeeeee;}
  
  
          .fab_kecil{
              width: 45px;
              height: 20px;
          }
  
  
          .tbl_responsive{
            overflow-x:auto;
          }

          .catat{
        display: grid; 
        grid-template-columns: 
        1fr 4fr 1fr; 
        grid-template-rows: 1fr; 
        grid-column-gap: 0px; 
        grid-row-gap: 0px;
      }

      .bsre {
        display: grid;
        grid-template-columns: 6fr 1fr;
        grid-template-rows: 1fr;
        grid-column-gap: 0px;
        grid-row-gap: px;
      }

      footer{
        position: absolute;
        left: 0;
        bottom: 0;
        height: 100px;
        width: 100%;
        overflow:hidden;
        font-size: 11.5px;
      }
  
          </style>
        `;
  
        printWindow.document.write('<html><head><title>Dinas Kesehatan Kabupaten Konawe Selatan</title>' + style + '</head><body>');
        printWindow.document.write(content);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
      },
  
      unduhData: function() {
  
        console.log(this.form.tahun.id);
  
        var tahun = this.form.tahun.id;
  
          var URLku = this.$store.state.url.URL_APP+'laporan_dikbud/pdfLansia/?tahunId='+tahun+''
          window.open(URLku);
      },
  
      selectData : function(data){
          this.form.id = data.id
          this.form.satuan = data.satuan
          this.form.skrining = data.skrining
          // this.form.tahun = data.thn
          this.form.createAt = data.createAt
      },
  
      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
          btn_prev : function(){
              this.cek_load_data = true;
              if(this.page_first>1){
                  this.page_first--
              }else{
                  this.page_first = 1;
              }
              this.getView();
          },
  
          btn_next : function(){
              if(this.page_first >= this.page_last){
                  this.page_first == this.page_last
              }else{
                  this.page_first++;
              }
              this.getView();
          },
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },
  
      // ====================================== PAGINATE ====================================
  
    },
  
    mounted () {
      this.getView();
      this.getTahun();
      this.getKecamatan();
      this.getKadis();
    },
  }
  